import { render, staticRenderFns } from "./PageTabsView.vue?vue&type=template&id=938c88c8&"
import script from "./PageTabsView.vue?vue&type=script&lang=js&"
export * from "./PageTabsView.vue?vue&type=script&lang=js&"
import style0 from "./PageTabsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports